import React from 'react';

import * as S from './styles';

interface IProps {
  title?: string;
  children: React.ReactNode;
}

const FormBox: React.FC<IProps> = ({ title, children }) => {
  return (
    <S.Container>
      {title && <S.Title>{title}</S.Title>}
      <S.ChildBox>{children}</S.ChildBox>
    </S.Container>
  );
};

export default FormBox;
